function validateEmailDekaz(inputgroup, placeholder, placeholdererror, keyup) {
    const input = inputgroup.querySelector('input')
    const label = inputgroup.querySelector('label')
    let se
    function validateEmail(email) {
        se = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))){2,6}$/i;
        return se.test(email);
    }

    if (!keyup) {
        if (!validateEmail(input.value)) {
            label.innerText = placeholdererror
            inputgroup.classList.add('invalid')
            inputgroup.classList.remove('valid');
            input.value = ''
            return false
        } else {
            label.innerText = placeholder
            inputgroup.classList.remove('invalid')
            inputgroup.classList.add('valid');
            return true
        }
    } else {
        if (input) {
            input.addEventListener('keyup', function () {
                if (validateEmail(input.value)) {
                    label.innerText = placeholder;
                    inputgroup.classList.remove('invalid')
                } else {
                    inputgroup.classList.add('invalid')
                    label.innerText = placeholdererror
                    

                }
                // console.log('keyup: %s', this.value);
                
            });
        }
    }

}

export default validateEmailDekaz